import { Component } from '@angular/core';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-spam',
  styles: [`
    :host {
      background:#fff;
    }
    a {
      font-size:12px;
      color:rgba(0,0,0, 0.6);
      padding:3px;
      background:#EBEFF1;
      border-radius:2px;
      box-sizing:border-box;
    }
    a:hover {background:#EBEFF1;}
    .nns-spam-link-text {padding:0 3px;}

    :host.nns-spam-link-reverse a {
      background:#fff;
    }
    :host.nns-spam-link-reverse a:hover {
      background:#fff;
    }
  `, `
    :host-context(.nns-theme-night),
    :host-context(.nns-theme-night) .nns-spam-link-reverse {
      background:#20252B;
    }
    :host-context(.nns-theme-night) a,
    :host-context(.nns-theme-night) .nns-spam-link-reverse a {
      background:#414B4C;
      color:rgba(255,255,255,0.60);
    }
    :host-context(.nns-theme-night) a:hover,
    :host-context(.nns-theme-night) .nns-spam-link-reverse a:hover {
      background:rgba(181,181,181,0.10);
      color:rgba(255,255,255,0.60);
    }
  `, `
    @media print {
      a {display:none !important;}
    }
  `],
  template: `
    <a class="nns-animated" [href]="_config.get('SPAM_LINK') | safeUrl" title="Report as spam"
      target="_blank" flex="none" layout="row" layout-align="start center">
      <nns-icon icon="spam-inv"></nns-icon>
      <span class="nns-spam-link-text not-mobile">Report as spam</span>
    </a>
  `
})
export class SpamComponent {
  link: string;
  constructor(
    public _config: Config
  ) {
  }
}
